import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';

import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { Column, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { HeaderContainer } from './ShopDetailsHeaderDesktop';

const ShopDetailsHeaderResponsive = props => (
  <HeaderContainer>
    <Container>
      <Column spaceBetweenJustified topAligned fullWidth>
        <Row topAligned fullWidth>
          {props.ShopLogo}
          <Spacer size={0.5} />
          <Column topAligned fullWidth>
            {props.shopName}
            <React.Fragment>
              <Spacer size={1} />
              <Row fullWidth spaceBetweenJustified>
                {props.Rating}
                {props.shopInfoIcon}
              </Row>
              <Spacer size={0.5} />
            </React.Fragment>
            <Row topAligned spaceBetweenJustified fullWidth>
              {props.responsiveActionButtons}
            </Row>
            <Spacer size={0.5} />
          </Column>
        </Row>
        <Column topAligned fullWidth>
          {props.ShopAddress}
        </Column>
      </Column>
    </Container>
  </HeaderContainer>
);

ShopDetailsHeaderResponsive.defaultProps = {
  ShopAddress: null,
};

ShopDetailsHeaderResponsive.propTypes = {
  shopName: PropTypes.element.isRequired,
  Rating: PropTypes.element.isRequired,
  ShopAddress: PropTypes.element,
  ShopLogo: PropTypes.element.isRequired,
  responsiveActionButtons: PropTypes.element.isRequired,
  shopInfoIcon: PropTypes.element.isRequired,
};

export default withMedia(ShopDetailsHeaderResponsive);
